import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Card, CardBody } from '../../components/card/card';

const ModalComponent = ({
  lastConnectedData,
  lastCleanedData,
  ingredientsHistoryData,
  deviceName,
  showLastConnectedTab = true,
  initialActiveTab,
  onShown, // <-- NEW (optional)
}) => {
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
    const tabs = [
      ...(showLastConnectedTab ? ['lastConnected'] : []),
      'lastCleaned',
      'ingredientsHistory'
    ];
    return initialActiveTab && tabs.includes(initialActiveTab) ? initialActiveTab : tabs[0];
  });

  // latch to call onShown only once per open
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (show) {
      const tabs = [
        ...(showLastConnectedTab ? ['lastConnected'] : []),
        'lastCleaned',
        'ingredientsHistory'
      ];
      const next = initialActiveTab && tabs.includes(initialActiveTab) ? initialActiveTab : tabs[0];
      setActiveTab(next);
    }
    // eslint-disable-next-line
  }, [show, showLastConnectedTab, initialActiveTab]);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

  function handleSelect(tab) {
    setActiveTab(tab);
  }

  const isArrayAndHasData = (data) => Array.isArray(data) && data.length > 0;

  return (
    <>
      <a
        href="#/"
        onClick={(e) => { e.preventDefault(); handleShow(true); }}
        className="text-inverse text-opacity-50 text-decoration-none"
      >
        <i className="bi bi-fullscreen"></i>
      </a>

      <Modal
        show={show}
        fullscreen={fullscreen}
        onHide={() => setShow(false)}
        onEntered={() => {
          if (!fetchedRef.current) {
            onShown?.();            // <-- fire fetch here (once per open)
            fetchedRef.current = true;
          }
        }}
        onExited={() => { fetchedRef.current = false; }} // reset latch after close
      >
        <Modal.Header closeButton>
          <Modal.Title>{deviceName} History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Card>
            <CardBody>
              <ul className="nav nav-tabs mb-3">
                {showLastConnectedTab && (
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === 'lastConnected' ? 'active' : ''}`}
                      onClick={() => handleSelect('lastConnected')}
                    >
                      Last Connected
                    </button>
                  </li>
                )}
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'lastCleaned' ? 'active' : ''}`}
                    onClick={() => handleSelect('lastCleaned')}
                  >
                    Last Cleaned
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'ingredientsHistory' ? 'active' : ''}`}
                    onClick={() => handleSelect('ingredientsHistory')}
                  >
                    Ingredients History
                  </button>
                </li>
              </ul>

              {activeTab === 'lastConnected' && (
                <>
                  <h6>Last Connected</h6>
                  {isArrayAndHasData(lastConnectedData) ? (
                    <table className="table table-borderless table-striped">
                      <thead>
                        <tr><th>Time</th><th>Date</th></tr>
                      </thead>
                      <tbody>
                        {lastConnectedData.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.time}</td>
                            <td>{item.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>No Last Connected data available.</div>
                  )}
                </>
              )}

              {activeTab === 'lastCleaned' && (
                <>
                  <h6 className="mt-4">Last Cleaned</h6>
                  {isArrayAndHasData(lastCleanedData) ? (
                    <table className="table table-borderless table-striped">
                      <thead>
                        <tr>
                          <th>Station A</th><th>Station B</th><th>Station C</th>
                          <th>Station D</th><th>Station E</th><th>Station F</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lastCleanedData.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.Station_A.time} {row.Station_A.date}</td>
                            <td>{row.Station_B.time} {row.Station_B.date}</td>
                            <td>{row.Station_C.time} {row.Station_C.date}</td>
                            <td>{row.Station_D.time} {row.Station_D.date}</td>
                            <td>{row.Station_E.time} {row.Station_E.date}</td>
                            <td>{row.Station_F.time} {row.Station_F.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>No Last Cleaned data available.</div>
                  )}
                </>
              )}

              {activeTab === 'ingredientsHistory' && (
                <>
                  <h6 className="mt-4">Ingredients History</h6>
                  {isArrayAndHasData(ingredientsHistoryData) ? (
                    <table className="table table-borderless table-striped">
                      <thead>
                        <tr><th>#</th><th>Ingredient (Count)</th></tr>
                      </thead>
                      <tbody>
                        {ingredientsHistoryData.map((item, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{item.ingredient} ({item.count})</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>No Ingredients History data available.</div>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { ModalComponent };
